module.exports = __webpack_public_path__ + "/images/ico-cta-amigos.ec5591e.svg";